import { SiteOperationalPhase } from '../../domain/entities/site-operational-phase';

type ApiData =
  | 'Planning'
  | 'Commissioning'
  | 'In Operation'
  | 'Monitoring Ended'
  | 'End Of Life';

const mapping: Record<ApiData, SiteOperationalPhase> = {
  Planning: SiteOperationalPhase.PLANNING,
  Commissioning: SiteOperationalPhase.COMMISSIONING,
  'In Operation': SiteOperationalPhase.IN_OPERATION,
  'Monitoring Ended': SiteOperationalPhase.MONITORING_ENDED,
  'End Of Life': SiteOperationalPhase.END_OF_LIFE,
};

export function siteOperationalPhaseMapper(
  data: ApiData,
): SiteOperationalPhase {
  return data in mapping ? mapping[data] : SiteOperationalPhase.PLANNING;
}
